import { useDebouncedState } from 'hooks/use-debounced-state'
import { usePagination } from 'hooks/use-pagination'
import { GET_SUBSCRIPTION_COURSES } from 'pages/Subscription/services'
import { useEffect, useState } from 'react'
import useSWR from 'swr'
import { TSubscriptionCourse } from '../types'

const ITEMS_PER_PAGE = 12

interface IParams {
  subscriptionId: string
}
export function useGetSubscriptionCourses(params: IParams) {
  const [totalPages, setTotalPages] = useState(1)

  const [name, setName] = useDebouncedState('', 500)
  const [state, setState] = useState('')
  const [career, setCareer] = useState('')

  const pagination = usePagination({ total: totalPages })

  const filter = {
    name,
    state,
    career,
  }

  const key = ['get-subscription-courses', filter, pagination.active, params.subscriptionId]

  const swr = useSWR<TSubscriptionCourse[]>(
    key,
    () => GET_SUBSCRIPTION_COURSES(pagination.active, filter, params.subscriptionId),
    { fallbackData: [] }
  )

  useEffect(() => {
    if (swr.isLoading) return

    const totalDocs = swr.data[0]?.totalDocs || 1

    setTotalPages(Math.ceil(totalDocs / ITEMS_PER_PAGE))
  }, [swr.data, swr.isLoading])

  const onParamChange = () => {
    pagination.first()
    setTotalPages(1)
  }

  return {
    swr,
    pagination,
    params: {
      name,
      state,
      career,

      setName: (value: string) => setName(value, onParamChange),
      setState: (value: string) => {
        setState(value)
        onParamChange()
      },
      setCareer: (value: string) => {
        setCareer(value)
        onParamChange()
      },
    },
  }
}
